import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, faqLD, SITE_URL } from "@/content/seo";

const TITLE = "Ria Formosa & Tavira Cruise from Vilamoura · Morningstar";
const DESC = "Private full-day cruise from Vilamoura to the Ria Formosa barrier islands — Farol, Armona, Culatra — one of Portugal's 7 Natural Wonders. Lunch onboard or ashore.";
const PATH = "/ria-formosa-tavira-cruise";
const URL = `${SITE_URL}${PATH}`;

export const Route = createFileRoute("/ria-formosa-tavira-cruise")({
  component: () => (
    <SitePage
      lang="en"
      heroOverride={{
        eyebrow: "Ria Formosa & Tavira · From Vilamoura · Algarve",
        title: "Ria Formosa & Tavira cruise from Vilamoura on ",
        titleAccent: "Morningstar.",
        sub: "A full-day private cruise east — golden barrier islands, calm Atlantic and lunch on Farol or Armona. Up to 18 guests, all-inclusive bar.",
        ctaPrimary: "View full days",
        ctaSecondary: "Plan my day",
      }}
    />
  ),
  head: () =>
    buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords: "Ria Formosa boat tour, Ria Formosa from Vilamoura, Farol Island cruise, Tavira boat trip, East Algarve cruise",
      altPath: { en: PATH, pt: "/pt/cruzeiro-ria-formosa-tavira" },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Ria Formosa & Tavira Cruise from Vilamoura",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Home", path: "/" },
              { name: "Ria Formosa & Tavira Cruise", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(faqLD("en")) },
      ],
    }),
});
